import React from 'react'
import classNames from 'classnames'
import { GiveawayContent } from './components/Content'
import { GiveawayFooter } from './components/Footer/GiveawayFooter'
import { GiveawayHeader } from './components/Header'
import { GiveawayModals } from './components/Modals/GiveawayModals'
import { GiveawayTabs } from './components/Tabs/GiveawayTabs'
import { FloatingButtons } from './components/UI/FloatingButtons'
import { GiveawaySeo } from './components/UI/GiveawaySeo'
import { useGiveawayContext } from './context/GiveawayContext'

export const GiveawayLayout: React.FC = () => {
  const { isScenePlayerOpen } = useGiveawayContext()

  return (
    <div className={classNames(isScenePlayerOpen ? 'fixed' : 'static')}>
      <GiveawaySeo />
      <GiveawayHeader />
      <GiveawayContent />
      <GiveawayTabs />
      <GiveawayFooter />
      <FloatingButtons />
      <GiveawayModals />
    </div>
  )
}
